<!--BasePage:v2 新页面框架 2024/02/29 15:38:03 YuAng-->
<template>
  <div class="base-page-v2" :class="{ 'no-head': routex.hideHeader,'base-page-v2-children':showChildren }">
    <navigator class="page-header" :class="routex.hideHeader" @change-show-children="changeShowChildren"></navigator>
    <router-view v-if="!routex.keepAlive" class="page-container" ></router-view>
    <keep-alive>
      <router-view v-if="routex.keepAlive" class="page-container keep-alive" ></router-view>
    </keep-alive>
    <footer-bar></footer-bar>
  </div>
</template>
<script>
import Navigator from './Navigator.vue';
import FooterBar from "@/components/FooterBar";

export default {
  name: 'BasePage',
  data () {
    return {
      aliveRoutes: [],
      showChildren: false
    };
  },
  computed: {
    routex: function () {
      return this.$route.meta || {}
    }
  },
  components: { Navigator, FooterBar },
  methods: {
    changeShowChildren (val = false) {
      this.showChildren = val
    }
  }
}
</script>

<style scoped>
.base-page-v2 {
  padding-top: 75px;
}

.base-page-v2-children{
  padding-top: 95px;
}

.page-container {
  padding: 0 16px;
  min-height: calc(100vh - 156px);
}

.no-head {
  padding-top: 0;
}

.no-head .page-container {
  min-height: auto;
}

.hide-header,
.hide-footer {
  display: none;
}

.base-page-v2>>>.el-button {
  font-size: 14px;
  font-weight: normal;
  padding: 6px 9px;
}

.base-page-v2>>>.el-button--primary.is-plain {
  border-color: #eaf1ff;
}

.base-page-v2>>>.el-button+.el-button {
  margin-left: 16px;
}

.base-page-v2>>>.el-button--primary:hover {
  background-color: #005eff;
  color: #fff;
}

.base-page-v2>>>.el-button.is-disabled {
  background-color: #f3f3f3;
  color: #333;
  border-color: #f3f3f3;
}

.page-footer {
  height: 102px;
  background: #eeeeee;
  color: #666666;
  text-align: center;
  font-size: 12px;
}
</style>
<style>
.cnt1200 {
  padding: 0 20px;
}

.page-empty {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: white;
  height: 751px;
}

.empty-text {
  color: #1A1A1A;
  margin: 20px 0 30px 0;
}

.el-dialog {
  border-radius: 5px;
}

.el-dialog__header {
  color: black;
  background: white;
  border-radius: 5px 5px 0 0;
  border-bottom: 1px solid #EEEEEE;
}

.el-dialog__title {
  color: black;
  font-size: 16px;
  font-weight: 400;
  padding-left: 20px;
}

.el-dialog__headerbtn .el-dialog__close,
.el-dialog__headerbtn:focus .el-dialog__close,
.el-dialog__headerbtn:hover .el-dialog__close {
  color: #BEBEBE;
}
</style>


// WEBPACK FOOTER //
// src/v2/views/components/BasePage.vue